import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {CreateClaimService} from "../../../claim/services/create-claim.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {VehicleDto} from "../../../auto-generated-server-dtos/warranty-search/vehicle-dto";

@Component({
  selector: 'app-vehicle-warranty',
  templateUrl: './vehicle-warranty.component.html',
  styleUrls: ['./vehicle-warranty.component.css']
})
export class VehicleWarrantyComponent implements OnInit {

  @Input() vehicle?: VehicleDto;
  @Input() searchTerm?: string;

  public startingNewClaim = false;

  startNewClaim(warrantyId: number): void {
    this.startingNewClaim = true;
    this.createClaimService.CreateClaim(warrantyId).subscribe(claimId => {
      this.startingNewClaim = false;
      this.ngbActiveModal.close();
      this.router.navigate(['/claim', claimId]);
    });
  }

  constructor(private createClaimService: CreateClaimService, private router: Router, private ngbActiveModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

}
